import React, { Fragment } from 'react';
import "./word-verbatims.css";
import Container from "../../components/container/container-component";
import SideContainer from "../../components/side-container/side-container-component";
import MainContainer from "../../components/main-container/main-container-component";
import Filters from "../filters/filters-container";
import Spinner from "../../components/spinner/spinner-component";
import Radio from "../../components/radio/radio-component";
import List from "../../components/list/list-component";
import Paginator from "../../components/paginator/paginator-component";
import ReportInfo from "../report-info/report-info-container";


const WordVerbatimsComponent = (
  {
    word,
    loading,
    error,
    general,
    negation,
    radio,
    radioSelect,
    selectedRadio,
    changePage,
    generalPage,
    negationPage,
    setSelectedText,
    showContextMenu
  }
) => {
  const data = selectedRadio === 'General' ? general : negation;
  const page = selectedRadio === 'General' ? generalPage : negationPage;
  const totalPages = Object.keys(data).length;
  return (
    <Container
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >

      <SideContainer>
        <Filters />
      </SideContainer>

      <MainContainer>
        <div className="report_info_container">
          <ReportInfo marginBottom />
        </div>
        <div className="verbatims_container">
        <div className="verbatims shadow" style={{
          justifyContent: loading || error ? 'center' : 'flex-start',
          alignItems: loading || error ? 'center' : null
        }}>
          {
            loading
              ?
              <Spinner
                loading={loading}
                fontSize="20px"
              />
              :
              error
              ?
                <span>{ error }</span>
                :
                <Fragment>

                  <div className="verbatims__header">
                    <div className="verbatims__radio">
                      <span style={{marginRight: '10px'}}>Contexts</span>
                      <Radio
                        data={radio}
                        select={radioSelect}
                        selected={selectedRadio}
                      />
                    </div>

                    <div className="verbatims__header__word">
                      <h2>Usages of term: "{word}"</h2>
                    </div>

                    <div className="verbatims__header__paginator">
                      {
                        totalPages ?
                          <Paginator
                            changePage={changePage}
                            meta={{
                              general: selectedRadio === 'General',
                              negation: selectedRadio === 'Negation'
                            }}
                            page={page}
                            data={data}
                            totalPages={totalPages}
                          />
                          :
                          null
                      }

                    </div>
                  </div>

                  <div className="verbatims__content">

                    {
                      selectedRadio === 'General'
                      ?
                        <List
                          data={general[generalPage] || []}
                          word={word}
                          showContextMenu={showContextMenu}
                          setSelectedText={setSelectedText}
                        />
                        :
                        <List
                          data={negation[negationPage] || []}
                          word={word}
                        />
                    }
                  </div>
                </Fragment>


          }
        </div>
        </div>

      </MainContainer>

    </Container>
  )
};

export default WordVerbatimsComponent


// WEBPACK FOOTER //
// ./src/modules/word-verbatims/word-verbatims-component.js